(ns minorodata.connections.sources.stripe
  (:require [minorodata.app.utils :as app.utils]
            [clojure.string :as c.string]
            [cljs.spec.alpha :as spec]
            [spec-tools.core :as st]))


(spec/def ::name
  (spec/and (st/spec string? {:reason "Please provide a name for the source"})
            (st/spec (complement c.string/blank?) {:reason "Name can't be empty"})))


(spec/def ::description (spec/nilable string?))


(spec/def ::stripe-token
  (spec/and (st/spec string? {:reason "Please provide a valid auth token"})
            (st/spec (complement c.string/blank?) {:reason "Auth token can't be empty"})))


(spec/def ::stripe-form
  (spec/and
   (spec/keys :req-un [::name ::stripe-token]
              :opt-un [::description])))


(def source
  {:id           "stripe"
   :enabled      false
   :name         "Stripe (Legacy)"
   :image-source "stripe.png"
   :description  "The best software platform for running an internet business"
   :tags         ["admin-finance"]

   :preview-formatter

   (fn [_] "Authenticated with an API key")

   :form
   {:format-for-api
    (fn [data]
      (let [{:keys [stripe-token name description]} data]
        {:source-type "stripe"
         :name        name
         :description description

         :source
         {:credentials {:stripe-token stripe-token}}}))

    :format-for-inputs
    (fn [data]
      (let [{:keys [source name description]} data
            {:keys [credentials]} source]
        (merge {:name        name
                :description description}
               (select-keys credentials [:stripe-token]))))

    :validate (constantly nil)

    :id :stripe-form

    :blocks [{:block-type :input
              :label      "Source name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:content "Authentication"
              :block-type :subtitle}
             {:content "Enter information required to connect to Stripe"}
             {:block-type :input
              :label      "API Key"
              :name       :stripe-token
              :type       :password
              :required   true
              :value      ""}

             {:block-type :submit
              :content    "SAVE"}]}


   :extract-form
   {:format-for-api
    (fn [{:keys [name description status balance-type
                 report action destination-table]}]
      {:name          name
       :description   (or description "")
       :status        status
       :output-tables [destination-table]

       :config
       {:extracts [{:action            action
                    :destination-table destination-table
                    :report            report
                    :balance-type      balance-type}]}})

    :format-for-inputs
    (fn [data]
      (let [{:extract/keys [name description status config]} data

            extract (get-in config [:extracts 0])]
        (merge
         (select-keys extract [:action :destination-table :report :balance-type])
         (app.utils/keep-non-nil-keys
          {:name          name
           :description   description
           :status        status
           :output-tables []}))))

    :validate (constantly nil)

    :id :stripe-extract-form

    :blocks [{:block-type :input
              :label      "Extract name"
              :required   true
              :name       :name
              :value      ""}
             {:block-type :input
              :label      "Description"
              :name       :description
              :value      ""}

             {:block-type :select
              :label      "Status"
              :name       :status
              :options    [{:name "Active" :value "active"}
                           {:name "Paused" :value "paused"}]
              :required   true
              :value      "active"}

             {:block-type :subtitle
              :content    "Extract Configuration"}

             {:block-type :select
              :label      "Report"
              :name       :report
              :options    [{:name "Events"               :value "events"}
                           {:name "Charges"              :value "charges"}
                           {:name "Customers"            :value "customers"}
                           {:name "Disputes"             :value "disputes"}
                           {:name "Payouts"              :value "payouts"}
                           {:name "Balance Transactions" :value "balance-transactions"}
                           {:name "Refunds"              :value "refunds"}]
              :required   true
              :value      "events"}


             {:block-type :select
              :label      "Balance Type"
              :name       :balance-type
              :options    [{:name "Adjustment", :value "adjustment"}
                           {:name "Advance", :value "advance"}
                           {:name "Advance Funding", :value "advance_funding"}
                           {:name "Anticipation Repayment", :value "anticipation_repayment"}
                           {:name "Application Fee", :value "application_fee"}
                           {:name "Application Fee Refund", :value "application_fee_refund"}
                           {:name "Charge", :value "charge"}
                           {:name "Connect Collection Transfer", :value "connect_collection_transfer"}
                           {:name "Contribution", :value "contribution"}
                           {:name "Issuing Authorization Hold", :value "issuing_authorization_hold"}
                           {:name "Issuing Authorization Release", :value "issuing_authorization_release"}
                           {:name "Issuing Dispute", :value "issuing_dispute"}
                           {:name "Issuing Transaction", :value "issuing_transaction"}
                           {:name "Payment", :value "payment"}
                           {:name "Payment Failure Refund", :value "payment_failure_refund"}
                           {:name "Payment Refund", :value "payment_refund"}
                           {:name "Payout", :value "payout"}
                           {:name "Payout Cancel", :value "payout_cancel"}
                           {:name "Payout Failure", :value "payout_failure"}
                           {:name "Refund", :value "refund"}
                           {:name "Refund Failure", :value "refund_failure"}
                           {:name "Reserve Transaction", :value "reserve_transaction"}
                           {:name "Reserved Funds", :value "reserved_funds"}
                           {:name "Stripe Fee", :value "stripe_fee"}
                           {:name "Stripe Fx Fee", :value "stripe_fx_fee"}
                           {:name "Tax Fee", :value "tax_fee"}
                           {:name "Topup", :value "topup"}
                           {:name "Topup Reversal", :value "topup_reversal"}
                           {:name "Transfer", :value "transfer"}
                           {:name "Transfer Cancel", :value "transfer_cancel"}
                           {:name "Transfer Failure", :value "transfer_failure"}
                           {:name "Transfer Refund", :value "transfer_refund"}]
              :required   true
              :value      "adjustment"
              :conditions [[:eq [:report :value] "balance-transactions"]]}

             {:content [:p "Note: Stripe Events API only guarantees up to 30 days"]
              :conditions [[:eq [:report :value] "events"]]}

             {:content [:p "Note: Stripe Charges API contains a lot of data and will considerably take a long to pull all data"]
              :conditions [[:eq [:report :value] "charges"]]}

             {:block-type :subtitle
              :content    "Data loading options"}

             {:block-type :select
              :label      "Load method"
              :name       :action
              :options    [{:name "Append" :value "append"}]
              :required   true
              :value      "append"}

             {:content "Load entire table (selected columns) into the destination table no table recreation, no truncation"
              :conditions [[:eq [:action :value] "append"]]}

             {:block-type :subtitle
              :content    "Destination table"}

             {:block-type  :warehouse-destination
              :name        :destination-table}

             {:block-type :submit
              :content    "SAVE"}]}})
